import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { VendorQuoteList } from 'quotes/components';

export const VendorQuoteListPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('titleVendorQuotes')} hasSwitchVersion>
      <SelectionCountProvider>
        <PageTitle title={t('titleVendorQuotes')} />
        <VendorQuoteList />
      </SelectionCountProvider>
    </PageLayout>
  );
};
